import { requestGet, api } from "../config/Api";

const name = "file/processed/txt";

export const getFile = (params) => {
  return requestGet(name, { params });
};

export const downloadFile = async (filename) => {
  return await api.get(`file/news/download/${filename}`, {
    responseType: "blob", // importante para que devuelva un archivo
  });
};

export const downloadFilePost = async (url, data = {}) => {
  return await api.post(url, data, {
    responseType: "blob",
  });
};
